"use strict";

class Ajaxinate {
  constructor(config = {}) {
    const defaultSettings = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    };
    this.settings = { ...defaultSettings, ...config };

    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.destroy = this.destroy.bind(this);

    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);

    this.initialize();
  }

  initialize() {
    if (this.containerElement) {
      const initializers = {
        click: this.addClickListener,
        scroll: this.addScrollListeners,
      };
      initializers[this.settings.method]();
    }
  }

  addScrollListeners() {
    if (this.paginationElement) {
      document.addEventListener("scroll", this.checkIfPaginationInView);
      window.addEventListener("resize", this.checkIfPaginationInView);
      window.addEventListener("orientationchange", this.checkIfPaginationInView);
    }
  }

  addClickListener() {
    if (this.paginationElement) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.clickActive = true;
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.addEventListener(
          "click",
          this.stopMultipleClicks
        );
      }
    }
  }

  stopMultipleClicks(event) {
    event.preventDefault();
    if (this.clickActive) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.clickActive = false;
      this.loadMore();
    }
  }

  checkIfPaginationInView() {
    const top =
      this.paginationElement.getBoundingClientRect().top - this.settings.offset;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom +
      this.settings.offset;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");
      this.removeScrollListener();
      if (this.nextPageLinkElement) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.loadMore();
      }
    }
  }

  loadMore() {
    this.request = new XMLHttpRequest();
    this.request.open("GET", this.nextPageUrl, true); 
    this.request.responseType = "document";
    this.request.onreadystatechange = () => {
      if (this.request.readyState === 4 && this.request.status === 200) {
        const responseXML = this.request.responseXML;
        const newContainer = responseXML.querySelector(this.settings.container);
        const newPagination = responseXML.querySelector(
          this.settings.pagination
        );

        if (newContainer && newPagination) {
          this.containerElement.insertAdjacentHTML(
            "beforeend",
            newContainer.innerHTML
          );
          this.paginationElement.innerHTML = newPagination.innerHTML;

          if (typeof this.settings.callback === "function") {
            this.settings.callback(responseXML);
          }
          this.initialize();
        }
      }
    };
    this.request.send();
  }

  removeClickListener() {
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener(
        "click",
        this.stopMultipleClicks
      );
    }
  }

  removeScrollListener() {
    document.removeEventListener("scroll", this.checkIfPaginationInView);
    window.removeEventListener("resize", this.checkIfPaginationInView);
    window.removeEventListener(
      "orientationchange",
      this.checkIfPaginationInView
    );
  }

  destroy() {
    const destroyers = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    };
    destroyers[this.settings.method]();
    return this;
  }
}
